var map = {
	"./1/level-card-banner1.png": "xfK1",
	"./2/level-card-banner1.png": "xCn7",
	"./3/level-card-banner1.png": "o0rz",
	"./4/level-card-banner1.png": "1q4T",
	"./5/level-card-banner1.png": "Ndw3",
	"./6/level-card-banner1.png": "pwFa",
	"./7/level-card-banner1.png": "iAdD",
	"./8/level-card-banner1.png": "M4AN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "03GH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/level\-card\-banner1\.png$
// module id = 03GH
// module chunks = 1